import { Quote } from 'lucide-react'
import type { HubPullQuoteSection, HubSectionComponentProps } from './types'

export function HubPullQuote({
  section,
  context,
}: HubSectionComponentProps<HubPullQuoteSection>) {
  if (!section.quote.trim()) return null

  const sourceReport = section.sourceReportId
    ? (context.reportsById[section.sourceReportId] ?? null)
    : null

  return (
    <section
      id={section.id}
      aria-label='Pull quote'
      className='flex flex-col gap-3 rounded-2xl border-l-4 border-info-300 bg-ds-bg-secondary px-5 py-5'
    >
      <Quote
        className='size-5 text-info-700'
        strokeWidth={2}
        aria-hidden='true'
      />
      <blockquote className='font-display text-lg leading-7 text-foreground md:text-xl'>
        {section.quote}
      </blockquote>
      {(section.attribution || section.attributionRole || sourceReport) && (
        <footer className='text-sm text-foreground-secondary'>
          {section.attribution && (
            <span className='font-semibold text-foreground'>
              {section.attribution}
            </span>
          )}
          {section.attribution && section.attributionRole && (
            <span className='text-foreground-tertiary'>, </span>
          )}
          {section.attributionRole && (
            <span className='text-foreground-secondary'>
              {section.attributionRole}
            </span>
          )}
          {sourceReport && (section.attribution || section.attributionRole) && (
            <span className='text-foreground-tertiary'> · </span>
          )}
          {sourceReport && (
            <a
              href={sourceReport.href}
              className='text-info-700 hover:underline'
            >
              {sourceReport.title}
            </a>
          )}
        </footer>
      )}
    </section>
  )
}
